module.exports = __webpack_public_path__ + "static/media/brand-refresh-map-pin.4083e1b4.svg";